import styled from 'styled-components';
import { useGetVehicleByIdQuery } from 'services/api/upload-vehicle';
import { useGetVehicleId } from '../../../../../../CreateVehicle/hooks/useGetVehicleId';
import { useViewVehicleContext, ViewSectionsList } from '../../../../context/ViewVehicleContext';
import { useEffect, useRef, useState } from 'react';
import { GradePercentage } from './GradePercentage';

const Wrapper = styled.div`
  position: relative;
`;

const Container = styled.div<{ showAfterFade: boolean; showBeforeFade: boolean }>`
  margin: 0;
  padding: 0;
  overflow: hidden;
  overflow-x: auto;
  width: 100%;
  display: flex;
  gap: 116px;
  padding-left: 75px;
  padding-right: 20px;

  &:before {
    content: '';
    display: ${props => (props.showBeforeFade ? 'block' : 'none')};
    right: 0;
    left: 0;
    width: 250px;
    position: absolute;
    height: 18px;
    pointer-events: none;
    background: linear-gradient(90deg, #ffffff 0%, rgba(255, 255, 255, 0) 100%);
  }

  &:after {
    content: '';
    display: ${props => (props.showAfterFade ? 'block' : 'none')};
    right: 0;
    top: 0;
    width: 250px;
    position: absolute;
    height: 18px;
    pointer-events: none;
    background: linear-gradient(90deg, rgba(255, 255, 255, 0) 0%, #ffffff 100%);
  }

  &::-webkit-scrollbar {
    display: none;
  }

  @media (max-width: 1024px) {
    &:after {
      width: 150px;
    }

    &:before {
      width: 150px;
    }
  }
`;

const Title = styled.div<{ isActive: boolean }>`
  font-family: Roboto;
  font-size: 18px;
  font-weight: 600;
  min-width: fit-content;
  line-height: 100%;
  cursor: pointer;
  text-transform: capitalize;
  color: ${props => (props.isActive ? '#000' : '#999999')};

  @media (max-width: 1024px) {
    font-size: 14px;
    line-height: 16.41px;
  }
`;

const TitleContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  width: 50px;
  min-width: fit-content;
`;

export const ViewVehicleSectionsHeader = () => {
  const { activeSection, setActiveSection } = useViewVehicleContext();

  const [scrollOffset, setScrollOffset] = useState(0);
  const [widthDiff, setWidthDiff] = useState(0);

  const vehicleId = useGetVehicleId();
  const { data: vehicle } = useGetVehicleByIdQuery(vehicleId);

  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (ref.current && vehicle) {
      setWidthDiff(ref.current.scrollWidth - ref.current.offsetWidth);
    }
  }, [vehicle]);

  useEffect(() => {
    const checkScrollPosition = (e: any) => {
      if (!ref.current) return;
      setScrollOffset(ref.current.scrollLeft);
    };
    if (ref && ref.current) {
      ref.current.addEventListener('scroll', checkScrollPosition, false);
      return () => ref.current?.removeEventListener('scroll', checkScrollPosition, false);
    }
  }, [ref.current]);

  if (!vehicle) return null;

  return (
    <Wrapper>
      <Container
        id="section-header-container"
        ref={ref}
        showBeforeFade={scrollOffset > 20}
        showAfterFade={scrollOffset < widthDiff}
      >
        {ViewSectionsList.map(section => {
          const isActive = activeSection === section;

          const handleClick = (e: React.MouseEvent<HTMLDivElement, MouseEvent>) => {
            setActiveSection(section);
            (e.target as any).scrollIntoView({ behavior: 'smooth', inline: 'center', block: 'nearest' });
          };

          return (
            <TitleContainer key={section}>
              <Title onClick={handleClick} isActive={isActive} key={section}>
                {section}
              </Title>
              {isActive && <GradePercentage section={section} />}
            </TitleContainer>
          );
        })}
      </Container>
    </Wrapper>
  );
};
